<template>
  <!-- メインコンテンツエリア -->
  <main class="l-main">
    <!-- ログインエリア -->
    <div class="l-main-content">
      <!-- ロゴ -->
      <login-logo />
      <!-- /ロゴ -->
      <login-form :password-reset-url="passwordResetUrl" />
      <!-- コピーライト -->
      <login-copyright />
      <!-- /コピーライト -->
    </div>
    <!-- /ログインエリア -->
  </main>
  <!-- /メインコンテンツエリア -->
</template>

<script>
export default {
  props: {
    passwordResetUrl: String,
  },
}
</script>
